import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SITE } from '../content/site';
import { pageByPath, langOfPath } from '../content';
import { CHROME, HOME } from '../content/chrome';

const Footer = () => {
  const lang = langOfPath(useLocation().pathname);
  const t = CHROME[lang];
  return (
    <footer className="bg-ink text-white">
      <div className="container mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to={HOME[lang]} className="inline-flex items-center gap-3 hover:opacity-80 transition-opacity">
              <img
                src="/logo512.png"
                alt={t.logoAlt}
                className="w-8 h-8 object-contain"
              />
              <div className="flex flex-col leading-none">
                <span className="font-serif text-xl font-semibold text-white">Expomis</span>
                <span className="text-[11px] tracking-wide text-white/50">{t.tagline}</span>
              </div>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed mt-5">
              {t.about}
            </p>
            <ul className="space-y-2 text-sm text-white/70 mt-6">
              <li><a href={SITE.phoneHref} className="hover:text-white">{SITE.phone}</a></li>
              <li><a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a></li>
              <li>{SITE.address}</li>
              {t.hours.map((h) => <li key={h}>{h}</li>)}
            </ul>
          </div>

          {t.columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold tracking-wide uppercase text-white/50 mb-5">{col.title}</h4>
              <ul className="space-y-3 text-sm text-white/70">
                {(col.groups || []).map((g) => (
                  <li key={g.path}>
                    <Link to={g.path} className="hover:text-white transition-colors">{pageByPath[g.path].nav}</Link>
                    <p className="mt-1.5 text-xs leading-relaxed text-white/50">
                      {g.cities.map((path, i) => (
                        <React.Fragment key={path}>
                          {i > 0 && ', '}
                          <Link to={path} className="hover:text-white transition-colors">
                            {pageByPath[path].nav.replace('Recherche de fuite à ', '')}
                          </Link>
                        </React.Fragment>
                      ))}
                    </p>
                  </li>
                ))}
                {(col.links || []).map((path) => (
                  <li key={path}>
                    <Link to={path} className="hover:text-white transition-colors">{pageByPath[path].nav}</Link>
                  </li>
                ))}
                {(col.extra || []).map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} lang={l.lang} className="hover:text-white transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
              {col.note && <p className="mt-4 text-xs leading-relaxed text-white/50">{col.note}</p>}
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center text-white/40 text-sm">
          <p>{`© ${new Date().getFullYear()} Expomis. ${t.rights}`}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
